import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { TextInput } from '../common/form/index';

import ValidationUtils from '../../util/ValidationUtils';

const PasswordResetForm = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <TextInput field="email" label="Email"/>
            <div className="form-error">{props.errorMsg}</div>
        </form>
    );
};

PasswordResetForm.propTypes = {
    errorMsg: PropTypes.string,
    onSubmit: PropTypes.func.isRequired
};

export default reduxForm({
    form: 'passwordReset',
    validate: ValidationUtils.validate,
    asyncValidate: ValidationUtils.asyncValidate,
})(PasswordResetForm);


// WEBPACK FOOTER //
// ./src/components/login/PasswordResetForm.js